import React, { PropsWithChildren } from 'react';
import './Header.scss';

type HeaderProps = {
  children: React.ReactNode;
};

function Header({ children }: PropsWithChildren<HeaderProps>) {
  return (
    <header className="header__wrapper">
      <section className="header__second-line">{children}</section>
    </header>
  );
}

export default Header;
